// removed by extract-text-webpack-plugin
module.exports = {"button":"export-button__button___2BiPp"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/export-button.scss
// module id = 1324
// module chunks = 0